import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Calendar as CalendarIcon, Clock, MapPin, Video } from 'lucide-react';
const TIME_SLOTS = ['9:00 AM', '10:00 AM', '11:00 AM', '1:00 PM', '2:00 PM', '3:00 PM', '4:00 PM'];
const SERVICES = ['Individual Counselling & Therapy', 'Couples Therapy', 'Family Therapy', 'Trauma Therapy', 'EMDR Therapy', 'Free Consultation'];
export function BookingCalendar() {
  const today = new Date();
  const [currentMonth, setCurrentMonth] = useState(new Date(today.getFullYear(), today.getMonth(), 1));
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [selectedTime, setSelectedTime] = useState<string | null>(null);
  const [selectedService, setSelectedService] = useState('');
  const [sessionType, setSessionType] = useState<'in-person' | 'virtual'>('in-person');
  const daysInMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 0).getDate();
  const firstDay = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 1).getDay();
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const isDisabled = (d: number) => {
    const dt = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), d);
    dt.setHours(23, 59, 59, 999);
    return dt < today;
  };
  const isWknd = (d: number) => {
    const dt = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), d);
    return dt.getDay() === 0 || dt.getDay() === 6;
  };
  const isSel = (d: number) => selectedDate ? selectedDate.getDate() === d && selectedDate.getMonth() === currentMonth.getMonth() && selectedDate.getFullYear() === currentMonth.getFullYear() : false;
  const isReady = selectedDate && selectedTime && selectedService;
  return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-55">
      <div data-id="element-56">
        <div className="max-w-2xl mx-auto bg-white rounded-2xl shadow-soft p-4 sm:p-6 md:p-8" data-id="element-57">
          <div className="mb-6" data-id="element-58">
            <div className="flex p-1 bg-charcoal/5 rounded-xl" data-id="element-59">
              <button onClick={() => setSessionType('in-person')} className={`flex-1 py-2.5 px-3 rounded-lg font-bold text-sm transition-all flex items-center justify-center gap-1.5 ${sessionType === 'in-person' ? 'bg-white text-charcoal shadow-sm' : 'text-charcoal/50'}`} data-id="element-60">
                <MapPin size={16} data-id="element-61" />
                In-Person
              </button>
              <button onClick={() => setSessionType('virtual')} className={`flex-1 py-2.5 px-3 rounded-lg font-bold text-sm transition-all flex items-center justify-center gap-1.5 ${sessionType === 'virtual' ? 'bg-white text-charcoal shadow-sm' : 'text-charcoal/50'}`} data-id="element-62">
                <Video size={16} data-id="element-63" />
                Virtual
              </button>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-64">
            <div data-id="element-65">
              <div className="flex items-center justify-between mb-4" data-id="element-66">
                <button onClick={() => setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1))} className="p-1.5 rounded-full hover:bg-charcoal/5 text-charcoal transition-colors" data-id="element-67">
                  <ChevronLeft size={18} data-id="element-68" />
                </button>
                <h3 className="font-heading font-bold text-base text-charcoal" data-id="element-69">
                  {months[currentMonth.getMonth()]} {currentMonth.getFullYear()}
                </h3>
                <button onClick={() => setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1))} className="p-1.5 rounded-full hover:bg-charcoal/5 text-charcoal transition-colors" data-id="element-70">
                  <ChevronRight size={18} data-id="element-71" />
                </button>
              </div>
              <div className="grid grid-cols-7 gap-0.5" data-id="element-72">
                {days.map(d => <div key={d} className="text-center text-xs font-bold text-charcoal/40 py-1.5 uppercase" data-id="element-73">
                    {d}
                  </div>)}
                {Array.from({
                length: firstDay
              }).map((_, i) => <div key={`e-${i}`} data-id="element-74" />)}
                {Array.from({
                length: daysInMonth
              }).map((_, i) => {
                const d = i + 1;
                const dis = isDisabled(d);
                const wk = isWknd(d);
                const sel = isSel(d);
                return <button key={d} onClick={() => {
                  if (!dis) {
                    setSelectedDate(new Date(currentMonth.getFullYear(), currentMonth.getMonth(), d));
                    setSelectedTime(null);
                  }
                }} disabled={dis} className={`aspect-square flex items-center justify-center rounded-full text-sm transition-all font-bold ${dis ? 'text-charcoal/15' : 'hover:bg-olive/10 cursor-pointer'} ${wk && !dis && !sel ? 'text-charcoal/50' : ''} ${!dis && !wk && !sel ? 'text-charcoal' : ''} ${sel ? 'bg-olive text-white' : ''}`} data-id="element-75">
                      {d}
                    </button>;
              })}
              </div>
            </div>

            <div className="space-y-5" data-id="element-76">
              <div data-id="element-77">
                <div className="flex items-center gap-1.5 text-charcoal font-bold mb-3 text-sm uppercase tracking-wide" data-id="element-78">
                  <Clock size={16} className="text-olive" data-id="element-79" />
                  <h4 data-id="element-80">Available Times</h4>
                </div>
                {!selectedDate ? <p className="text-sm text-charcoal/40 italic" data-id="element-81">
                    Select a date first.
                  </p> : <div className="grid grid-cols-2 gap-2" data-id="element-82">
                    {TIME_SLOTS.map(t => <button key={t} onClick={() => setSelectedTime(t)} className={`py-2.5 text-sm rounded-lg border transition-all font-bold ${selectedTime === t ? 'bg-olive border-olive text-white' : 'border-charcoal/10 text-charcoal hover:border-olive/30'}`} data-id="element-83">
                        {t}
                      </button>)}
                  </div>}
              </div>
              <div data-id="element-84">
                <label htmlFor="booking-service" className="block text-sm font-bold text-charcoal mb-2 uppercase tracking-wide" data-id="element-85">
                  Service Type
                </label>
                <select id="booking-service" value={selectedService} onChange={e => setSelectedService(e.target.value)} className="w-full px-3 py-3 rounded-lg border border-charcoal/10 bg-white focus:border-olive focus:ring-1 focus:ring-olive/20 outline-none transition-all font-medium text-charcoal text-base" data-id="element-86">
                  <option value="" disabled data-id="element-87">
                    Select a service...
                  </option>
                  {SERVICES.map(s => <option key={s} value={s} data-id="element-88">
                      {s}
                    </option>)}
                </select>
              </div>
              <button disabled={!isReady} className={`w-full py-3.5 rounded-lg font-bold text-base transition-all min-h-[48px] flex items-center justify-center gap-2 ${isReady ? 'bg-olive hover:bg-olive/90 text-white shadow-soft' : 'bg-charcoal/10 text-charcoal/30 cursor-not-allowed'}`} data-id="element-89">
                <CalendarIcon size={18} data-id="element-90" />
                Confirm Booking
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}